import type { SheetThicknessInputs } from "./types";

export const defaultSheetThicknessInputs: SheetThicknessInputs = {
  aMass: 5
};
